import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { UserScope, BuildingUserOptionType } from '../../../../../../store/buildinguser/types';
import { Notification } from '../../../../../Notification';
import { PrimaryButton } from '../../../../../PrimaryButton';
import { BuildingUserActions } from '../../../../../../store';
import { GreyButton } from '../../../../../GreyButton';
import { Spinner } from '../../../../../Spinner';
import { SelectedBuilding } from '../../../../../../store/building/types';

export interface Props {
  inviteCreated: boolean;
  closeAddNewUser(): void;
  createUserInvite(email: string, building: string, userType: string, userScope: UserScope[]): void;
  userScopes: UserScope[];
  buildings: SelectedBuilding[];
  isLoading: boolean;
  error: string;
}

interface State {
  email: string;
  building: BuildingUserOptionType[];
  userType: string;
  buildingOptions: BuildingUserOptionType[];
  userScope: BuildingUserOptionType[];
  userScopeOptions: BuildingUserOptionType[];
  showResultPage: boolean;
}

const userTypeOptions = [
  {
    label: 'Board Member',
    value: 'board_member',
  },
  {
    label: 'Property Manager',
    value: 'property_manager',
  },
  {
    label: 'Engineer',
    value: 'engineer',
  },
  {
    label: 'Mechanical Provider',
    value: 'mechanical',
  },
  {
    label: 'Installer',
    value: 'installer',
  },
];

export class AddUserForm extends Component<Props, State> {
  state = {
    email: '',
    building: [],
    userType: '',
    buildingOptions: [],
    userScope: [],
    userScopeOptions: [],
    showResultPage: false,
  };

  componentDidMount() {
    const { userScopes, buildings } = this.props;
    const tempBuildingOptions: BuildingUserOptionType[] = [];
    const tempUserScopeOptions: BuildingUserOptionType[] = [];

    buildings.map((building) => {
      tempBuildingOptions.push({
        label: building.name,
        value: building.identifier,
      });
    });

    userScopes.map((userScope) => {
      tempUserScopeOptions.push({
        label: userScope.name,
        value: userScope.identifier,
        disabled: userScope.is_read_only,
      });
    });

    this.setState((state) => ({
      ...state,
      buildingOptions: tempBuildingOptions,
      userScopeOptions: tempUserScopeOptions,
    }));
  }

  componentDidUpdate(prevProps: Props) {
    const { userScopes } = prevProps;

    const { userScopes: newUserScopes } = this.props;
    const tempUserScopeOptions: BuildingUserOptionType[] = [];

    if (userScopes.length !== newUserScopes.length) {
      newUserScopes.map((userScope) => {
        tempUserScopeOptions.push({
          label: userScope.name,
          value: userScope.identifier,
          disabled: userScope.is_read_only,
        });
      });

      this.setState((state) => ({
        ...state,
        userScopeOptions: tempUserScopeOptions,
      }));
    }
  }

  onBuildingChange = (option: any) => {
    this.setState((state) => ({
      ...state,
      building: option,
    }));
  };

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.currentTarget;

    this.setState((state) => ({
      ...state,
      [name]: value,
    }));
  };

  handleClose = () => {
    const { closeAddNewUser } = this.props;

    this.setState(
      (state) => ({
        ...state,
        showResultPage: false,
      }),
      () => closeAddNewUser(),
    );
  };

  onUserScopeChange = (option: any) => {
    this.setState((state) => ({
      ...state,
      userScope: option,
    }));
  };

  onUserTypeChange = (userType: string) => {
    this.setState((state) => ({
      ...state,
      userType,
    }));
  };

  createUserInvite = () => {
    const { email, building, userType, userScope } = this.state;
    const { createUserInvite, userScopes } = this.props;

    if (email && building && userType) {
      building.map((obj: BuildingUserOptionType) => {
        const userScopeObjs: UserScope[] = [];

        userScope.map((scope: BuildingUserOptionType) => {
          const foundScope = userScopes.find((option) => option.identifier === scope.value);

          if (foundScope) {
            userScopeObjs.push(foundScope);
          }
        });

        createUserInvite(email, obj.value, userType, userScopeObjs);

        this.setState((state) => ({
          ...state,
          inviteSent: true,
          showResultPage: true,
        }));
      });
    }
  };

  render() {
    const { inviteCreated, isLoading, error } = this.props;
    const { email, building, userType, buildingOptions, userScope, userScopeOptions, showResultPage } = this.state;

    const customStyles = {
      control: (styles: any) => ({
        ...styles,
        height: 'auto',
        border: '1px solid #abadae',
        margin: '1.2rem 0',
        boxShadow: '0 1px 0 0 rgba(46, 50, 53, 0.1)',
        fontWeight: '400',
        textAlign: 'left',
      }),
      option: (provided: any) => ({
        ...provided,
        fontWeight: '400',
        textAlign: 'left',
      }),
    };

    if (isLoading && !error) {
      return (
        <div className="account-form">
          <Spinner />
        </div>
      );
    }

    if (showResultPage) {
      if (error) {
        return (
          <div className="account-form">
            <div className="account__body-header">
              <span className="account__body-title">Add Building User</span>
            </div>
            <Notification type="error" message={error} />
            <div className="account__button-wrapper">
              <PrimaryButton label="Return to list of users" onClick={this.handleClose} fullWidth={true} />
            </div>
          </div>
        );
      } else if (inviteCreated) {
        return (
          <div className="account-form">
            <div className="account__body-header">
              <span className="account__body-title">Add Building User</span>
            </div>
            <Notification type="success" message="User invite successfully created!" />
            <div className="account__button-wrapper">
              <PrimaryButton label="Return to list of users" onClick={this.handleClose} fullWidth={true} />
            </div>
          </div>
        );
      }
    }

    return (
      <div className="account-form">
        <div className="account__body-header">
          <span className="account__body-title">Add Building User</span>
        </div>
        <div className="account__input-wrapper">
          <label htmlFor="email" className="account-field">
            <span className="account__input-text">Email:</span>
            <input
              className="account__input"
              value={email}
              onChange={(e) => this.handleChange(e)}
              type="email"
              id="email"
              name="email"
              placeholder="Email"
            />
          </label>
        </div>
        <div className="account__input-wrapper">
          <label htmlFor="building-slug" className="account-field">
            <span className="account__input-text">Building:</span>
            <Select
              id="building-slug"
              name="building-slug"
              options={buildingOptions}
              styles={customStyles}
              className="account__dropdown"
              onChange={(selectedOption: any) => {
                this.onBuildingChange(selectedOption);
              }}
              value={building}
              isMulti={true}
            />
          </label>
        </div>
        <div className="account__input-wrapper">
          <label htmlFor="user-scopes" className="account-field">
            <span className="account__input-text">Permissions:</span>
            <Select
              id="user-scopes"
              name="user-scopes"
              options={userScopeOptions}
              styles={customStyles}
              className="account__dropdown"
              onChange={(selectedOption: any) => {
                this.onUserScopeChange(selectedOption);
              }}
              isOptionDisabled={(option: BuildingUserOptionType) => option.disabled === true}
              value={userScope}
              isMulti={true}
            />
          </label>
        </div>
        <div className="account__input-wrapper">
          <label htmlFor="user-type" className="account-field">
            <span className="account__input-text">Role:</span>
            <Select
              id="user-type"
              name="user-role"
              options={userTypeOptions}
              styles={customStyles}
              className="account__dropdown"
              onChange={(selectedOption: any) => {
                this.onUserTypeChange(selectedOption.value);
              }}
              value={userTypeOptions.filter((option: BuildingUserOptionType) => option.value === userType)}
            />
          </label>
        </div>
        <div className="account__buttons">
          <div className="account__button-wrapper">
            <GreyButton label="Cancel" onClick={this.handleClose} fullWidth={true} />
          </div>
          <div className="account__button-wrapper">
            <PrimaryButton
              label="Send User Invite"
              isDisabled={!(email.trim().length > 0 && building.length > 0 && userType.trim().length > 0)}
              onClick={this.createUserInvite}
              fullWidth={true}
            />
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    buildings: state.buildingReducer.buildingsList,
    inviteCreated: state.buildingUserReducer.inviteCreated,
    userScopes: state.buildingUserReducer.userScopes,
    isLoading: state.buildingUserReducer.isLoading,
    error: state.buildingUserReducer.error,
  };
}

const mapDispatchToProps = {
  createUserInvite: BuildingUserActions.createUserInvite,
};

export const ConnectedAddUserForm = connect(mapStateToProps, mapDispatchToProps)(AddUserForm);
